import axios from "axios";

const WORLDSKILLS_API_URL = process.env.REACT_APP_WORLDSKILLS_API_URL;
const PSYFIERS_API_URL = process.env.REACT_APP_PSYFIERS_API_URL;
const MISSION_TEAM_API_URL = process.env.REACT_APP_MISSION_TEAM_API_URL;
const MT_API_URL = process.env.REACT_APP_MT_API_URL;

export const fetchTranslations = (id) => {
  return axios.get(`${WORLDSKILLS_API_URL}/public/translations/${id}`);
};

export const getPortalDetails = async (m, p, mp) => {
  try {
    const result = await axios.get(`${PSYFIERS_API_URL}/public/inperson-workshop-details`, {
      params: { m, p, mp }
    });

    return result;
  } catch (error) {
    const result = await axios.get(`${MT_API_URL}/public/workshop/inperson-workshop-details`, {
      params: { m, p, mp }
    });

    return { ...result, mtW: true };
  }
};

export const getWorkshopInsightsData = async (id) => {
  try {
    const result = await axios.get(`${PSYFIERS_API_URL}/public/workshop-insights/${id}`);

    return result;
  } catch (error) {
    const result = await axios.get(`${MT_API_URL}/public/workshop/workshop-insights/${id}`);

    return { ...result, mtW: true };
  }
};

export const getBoosterWorkshopDetails = (id) =>
  axios.get(`${MISSION_TEAM_API_URL}/public/booster/${id}`);
